import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PutHistoryReadDTO } from '@/services/history/service/history.repository.interface';
import { PutHistoryRead } from '@/infrastructure/api-functions/interface/put-history-read.interface';

@injectable()
export class PutHistoryReadDTOImpl implements PutHistoryReadDTO {
    constructor(
        @inject(PutHistoryRead)
        private readonly _putHistoryReadApi: PutHistoryRead,
    ) { }

    async fetch(taskId: string): Promise<void> {
        await this._putHistoryReadApi.putHistoryRead(taskId);
    }
}
